<template>
    <b-card no-body>
        <b-modal id="modal-language" :title="editing ? 'Dil Güncelle' : 'Yeni Dil Ekle'" size="lg" no-close-on-backdrop>
            <language-form v-model="editedItem" :errors="errors" />
            <template #modal-footer>
                <v-executer :loading="loading" :action="save" :text="editing ? 'Güncelle' : 'Oluştur'" />
            </template>
        </b-modal>

        <v-table ref="table" :fields="fields" :items-provider="provider" :add-callback="createNew" :buttons="buttons" pagination="client">
            <template #cell(IsDefault)="data">
                <b-badge :variant="data.value ? 'primary' : 'light-secondary'">
                    {{ data.value ? "Varsayılan" : "-" }}
                </b-badge>
            </template>

            <template #cell(IsActive)="data">
                <b-form-checkbox :checked="data.value" switch @change="changeStatus(data.item)">
                    {{ data.value ? "Aktif" : "Pasif" }}
                </b-form-checkbox>
            </template>

            <template #cell(FlagIcon)="data">
                <span v-if="data.value" class="flag-icon">{{ data.value }}</span>
            </template>
        </v-table>
    </b-card>
</template>

<script>
import { BCard, BBadge, BFormCheckbox } from "bootstrap-vue";
import WebsiteApi from "@/api/website";
import LanguageForm from "./components/LanguageForm.vue";

export default {
    name: "LanguageManagement",
    components: {
        BCard,
        BBadge,
        BFormCheckbox,
        LanguageForm,
    },
    data() {
        return {
            loading: false,
            editing: false,
            errors: {},
            fields: [
                { name: "Dil Kodu", key: "LanguageCode", sortable: true },
                { name: "Dil Adı", key: "LanguageName", sortable: true },
                {
                    name: "Bayrak",
                    key: "FlagIcon",
                    sortable: false,
                    tdClass: "text-center",
                    component: true,
                    componentOptions: { name: "website/TableFlagCell" },
                },
                { name: "Varsayılan", key: "IsDefault", sortable: true, tdClass: "text-center" },
                { name: "Durum", key: "IsActive", sortable: true, tdClass: "text-center" },
                { name: "Sıra", key: "SortOrder", sortable: true, tdClass: "text-center" },
            ],
            buttons: [
                { text: "Düzenle", key: "edit", icon: "Edit2Icon", variant: "secondary", action: this.edit },
                { text: "Sil", key: "delete", icon: "TrashIcon", variant: "danger", action: this.deleteItem },
            ],
            editedItem: {
                id: null,
                languageCode: "",
                languageName: "",
                isDefault: false,
                isActive: true,
                sortOrder: 0,
                flagIcon: "",
            },
        };
    },
    methods: {
        provider() {
            return WebsiteApi.Language.GetAll();
        },

        clearForm() {
            this.editing = false;
            this.errors = {};
            this.editedItem = {
                id: null,
                languageCode: "",
                languageName: "",
                isDefault: false,
                isActive: true,
                sortOrder: 0,
                flagIcon: "",
            };
        },

        createNew() {
            this.clearForm();
            this.$bvModal.show("modal-language");
        },

        edit(item) {
            this.clearForm();
            this.editing = true;
            this.editedItem = {
                id: item.Id,
                languageCode: item.LanguageCode,
                languageName: item.LanguageName,
                isDefault: item.IsDefault,
                isActive: item.IsActive,
                sortOrder: item.SortOrder,
                flagIcon: item.FlagIcon,
            };
            this.$bvModal.show("modal-language");
        },

        save() {
            this.errors = {};

            if (!this.editedItem.languageCode) {
                this.$set(this.errors, "languageCode", "Dil kodu zorunludur.");
                return;
            }

            if (!this.editedItem.languageName) {
                this.$set(this.errors, "languageName", "Dil adı zorunludur.");
                return;
            }

            const payload = {
                LanguageCode: this.editedItem.languageCode,
                LanguageName: this.editedItem.languageName,
                IsDefault: this.editedItem.isDefault,
                IsActive: this.editedItem.isActive,
                SortOrder: this.editedItem.sortOrder,
                FlagIcon: this.editedItem.flagIcon,
            };

            this.loading = true;

            const apiCall = this.editing ? WebsiteApi.Language.Update(this.editedItem.id, payload) : WebsiteApi.Language.Create(payload);

            apiCall
                .then((response) => {
                    if (response.data.Success) {
                        this.$refs.table.refresh();
                        this.$bvModal.hide("modal-language");
                    } else if (response.data && response.data.errors) {
                        this.errors = response.data.errors;
                    }
                    this.$result(response);
                })
                .catch((err) => {
                    if (err.response && err.response.data && err.response.data.errors) {
                        this.errors = err.response.data.errors;
                    }
                    this.$result(null, err);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        changeStatus(item) {
            WebsiteApi.Language.ChangeStatus(item.Id)
                .then((response) => {
                    if (response.data.Success) {
                        this.$refs.table.refresh();
                    }
                    this.$result(response);
                })
                .catch((err) => {
                    this.$result(null, err);
                });
        },

        deleteItem(item) {
            if (item.IsDefault) {
                this.$toast.warning("Varsayılan dil silinemez!");
                return;
            }

            this.$confirm("Dili Sil", `"${item.LanguageName}" dilini silmek istediğinize emin misiniz? Bu dile ait tüm çeviriler silinecektir.`).then((result) => {
                if (result) {
                    WebsiteApi.Language.Delete(item.Id)
                        .then((response) => {
                            if (response.data.Success) {
                                this.$refs.table.refresh();
                            }
                            this.$result(response);
                        })
                        .catch((err) => {
                            this.$result(null, err);
                        });
                }
            });
        },
    },
};
</script>

<style scoped>
.flag-icon {
    font-size: 24px;
}
</style>
